import { ProfileTab } from "./admin/ProfileTab";

/** Профиль текущего пользователя: подключение Telegram для уведомлений. Доступен всем. */
export function ProfilePage() {
  return (
    <>
      <div className="page-header">
        <h1>Профиль</h1>
      </div>
      <ProfileTab />
    </>
  );
}
